import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'overAllSalesReport'
})
export class OverAllSalesReportPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    return null;
  }

}
